import React, { useState, useEffect } from "react";
import Helpers from "../../helpers/shared.helper";
import Storage from "../../services/storage.service";
import Payments from "../../services/payments.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import BillPaymentService from "../../services/bill-payment.service";
import BillPaymentFailed from "./bill-payment-failed";
import BillPaymentSuccess from "./bill-payment-success";
import PaymentFailureSimDeactivation from "../simDeactivation/payment-failure-sim-deactivation";
import PaymentSuccessSimDeactivation from "../simDeactivation/payment-success-sim-deactivation";

let subscriptions = []
const ConfirmationBillPaymentTAP = (props) => {
    const [success, setSuccess] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        if (!Storage.get("calledFeatureConfirmation", true)) {
            if (window) {
                Helpers.log(window.location);
                Storage.clear("paymentFailedError");

                if (localStorage.getItem("order_id") && localStorage.getItem("status")) {
                    let order_id = null;
                    let status = null;
                    
                    let order_id_obj = JSON.parse(localStorage.getItem("order_id"));
                    let status_obj = JSON.parse(localStorage.getItem("status"));
                    
                    order_id = order_id_obj[Storage.get("session")];
                    status = status_obj[Storage.get("session")];
        
                    let data = {
                        order_id: order_id,
                        status: status,
                    };

                    Helpers.log("order_id = " + order_id);
                    Helpers.log("Before verifyTAPResponse data: ", data);
                    Storage.set("paymentFailedError", true, true);

                    if(order_id && status) {
                        Storage.set("calledFeatureConfirmation", true, true)
                        BillPaymentService.billPaymentVerifyTap(data)
                            .then(response => {
                                Storage.clear("paymentFailedError");
                                if (response.status === 201) {
                                    Storage.set("confirmSuccess", true, true);
                                    localStorage.removeItem('order_id');
                                } else {
                                    Storage.set("paymentFailedError", true, true);
                                    Storage.set("confirmFailed", true, true);
                                }
                            })
                            .catch(error => {
                                Storage.set("paymentFailedError", true, true);
                                Helpers.log("verifyTAPResponse catch: ", error);
                                Payments.actionOnPaymentFail();
                                Storage.set("confirmFailed", true, true);
                            });
                    }
                } else {
                    Storage.set("paymentFailedError", true, true);
                    Helpers.log("no order id found");
                    Payments.actionOnPaymentFail();
                    Storage.set("confirmFailed", true, true);
                }
            }
        }
    }, []);


    useEffect(() => {
        subscriptions.push(
            Storage.get_obsrv("confirmSuccess").subscribe(() => {
                const flowType = Storage.get("confirmSuccess", true);
                if(JSON.parse(flowType)) {
                    setSuccess(true);        
                }
            })
        );

        subscriptions.push(
            Storage.get_obsrv("confirmFailed").subscribe(() => {
                const flowType = Storage.get("confirmFailed", true);
                if(JSON.parse(flowType)) {
                    setFailed(true);        
                }
            })
        );

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        };
    }, []);

    let content = (
        <div className="loading-overlay">
            <div className="relative">
                <SpinnerTimeLoader />
            </div>
        </div>
    );

    if (Storage.get("confirmSuccess", true) || success) {
        if(props?.sim_deactivation) {
            content = <PaymentSuccessSimDeactivation history={props.history}/>;
        } else {
            content = <BillPaymentSuccess />;
        }
    }
    if (Storage.get("confirmFailed", true) || failed) {
        if(props?.sim_deactivation) {
            content = <PaymentFailureSimDeactivation history={props.history}/>;
        } else {
            content = <BillPaymentFailed history={props.history}/>;
        }
    }

    return content;
};

export default ConfirmationBillPaymentTAP;
